import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API } from '../context/AuthContext';

export default function CoinSearch({ value, onChange, onSelect }) {
  const [query, setQuery] = useState(value || '');
  const [coins, setCoins] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    axios.get(`${API}/api/prices/list`)
      .then(res => setCoins(res.data.coins || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (query.length === 0) { setFiltered([]); setOpen(false); return; }
    const q = query.toUpperCase();
    const results = coins.filter(c =>
      !c.symbol.includes('_') &&
      (c.symbol.toUpperCase().includes(q) || c.name.toUpperCase().includes(q))
    ).slice(0, 8);
    setFiltered(results);
    setOpen(results.length > 0);
  }, [query, coins]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = (coin) => {
    setQuery(coin.symbol.toUpperCase());
    setOpen(false);
    onSelect(coin.symbol.toUpperCase(), coin.name);
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        style={inputStyle}
        value={query}
        onChange={e => { setQuery(e.target.value); onChange(e.target.value); }}
        placeholder="Search coin (e.g. XRP, BTC)"
        autoComplete="off"
      />
      {open && (
        <div style={dropdownStyle}>
          {filtered.map(coin => (
            <div key={coin.symbol} style={itemStyle} onMouseDown={() => handleSelect(coin)}>
              <span style={symbolStyle}>{coin.symbol.toUpperCase()}</span>
              <span style={nameStyle}>{coin.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const inputStyle = { width: '100%', padding: '11px 14px', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '8px', fontSize: '14px', color: '#1a1a1a', outline: 'none', fontFamily: "'Inter', system-ui, sans-serif", background: '#fff', boxSizing: 'border-box' };
const dropdownStyle = { position: 'absolute', top: '100%', left: 0, right: 0, marginTop: '4px', background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '10px', boxShadow: '0 12px 28px -8px rgba(16,40,28,0.2)', zIndex: 100, maxHeight: '240px', overflowY: 'auto' };
const itemStyle = { display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid rgba(0,0,0,0.06)', fontSize: '14px' };
const symbolStyle = { fontWeight: '500', color: '#1a1a1a', minWidth: '60px' };
const nameStyle = { color: '#6b6b6b', flex: 1 };
